import {takeEvery} from 'redux-saga/effects'
import {
  GET_MULTI_EXAM_GRID,
  GET_MULTI_EXAM_VERIFY,
  GET_SUBSECTION_EXAMS,
  GET_SUBSECTION_EXAM_RESULTS,
  RECALCULATE_EXAM_TOTALS,
  SAVE_MULTI_EXAM_VERIFY,
  SAVE_SUBSECTION_EXAMS,
  SAVE_SUBSECTION_EXAM_MARKS,
} from 'setup/redux/Actions/MultiExam/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_MULTI_EXAM_VERIFY, fetchData)
  yield takeEvery(SAVE_MULTI_EXAM_VERIFY, fetchData)
  yield takeEvery(GET_MULTI_EXAM_GRID, fetchData)
  yield takeEvery(GET_SUBSECTION_EXAMS, fetchData)
  yield takeEvery(SAVE_SUBSECTION_EXAMS, fetchData)
  yield takeEvery(GET_SUBSECTION_EXAM_RESULTS, fetchData)
  yield takeEvery(SAVE_SUBSECTION_EXAM_MARKS, fetchData)
  yield takeEvery(RECALCULATE_EXAM_TOTALS, fetchData)
}

export default dataSaga
